module.exports = __webpack_public_path__ + "img/pps_error.80af75a3.jpg";